import styled from 'styled-components';
import { Colors } from '../../constants/Colors';

export const ActionsCell = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconButton = styled.button<{ $danger?: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ $danger }) => ($danger ? Colors?.secondary[100] || '#d00' : Colors?.commons.darkGray || '#555')};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;

  &:hover {
    opacity: 0.7;
  }
`;

export const AddButton = styled.button`
  background-color: ${Colors?.primary?.[100] || '#007BFF'};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  font-weight: bold;
  cursor: pointer;
  
  &:hover {
    filter: brightness(0.9);
  }
`;
